<template>
  <div class="mt-4">
    <div class="row">
      <div class="col-12">
        <cabecalho title="ACADEMICO_MATRICULAS.DADOS_ALUNO" title_type="body" />
      </div>
      <div class="col-12 col-md-6">
        <input-text
          v-if="form.codigoMatricula || $route.params.idPessoa"
          :label="$t('ACADEMICO_MATRICULAS.ALUNO')"
          :value="form.nome"
          disabled
        />
        <InputSelectTyping
          ref="pessoaId"
          :options="pessoas"
          v-model="form.pessoaId"
          :label="$t('ACADEMICO_MATRICULAS.ALUNO')"
          placeholder="Selecione ou digite"
          required
          @pesquisa-nome="buscarPessoasSemMatriculaPorNome"
          v-else
          :loading="loadingPessoas"
        />
      </div>
      <div class="col-md-6 col-12">
        <input-select-multiple
          ref="instituicaoEnsinoId"
          class="mb-4"
          v-model="form.escolaOrigemId"
          label="Instituição de origem:"
          placeholder="Digite ou procure"
          :options="listaInstituicoesDeEnsino"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="d-flex justify-content-between ml-3 mr-2" style="width: 100%">
        <div>
          <cabecalho
            title="ACADEMICO_MATRICULAS.DADOS_RESPONSAVEIS"
            title_type="body"
          />
        </div>
        <div>
          <router-link
            class="btn text-nowrap mr-3 btn-info"
            :to="{ name: 'nova-pessoa' }"
            target="_blank"
            >{{ $t('ACADEMICO_MATRICULAS.NOVA_PESSOA') }}</router-link
          >
          <b-button variant="primary" @click="abrirModalPessoaResponsavel">
            {{ $t('ACADEMICO_MATRICULAS.ADICIONAR_PESSOA_TABELA') }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <b-table
        :empty-text="$t('GERAL.NENHUM_REGISTRO')"
        head-variant="light"
        :fields="camposVinculos"
        :items="form.vinculos"
        show-empty
        responsive
        striped
        hover
      >
        <template #cell(contatos)="item">
          <b-button variant="primary" @click="abrirModalContatos(item.item)">
            Contatos
          </b-button>
        </template>
        <template #cell(enderecos)="item">
          <b-button variant="primary" @click="abrirModalEnderecos(item.item)">
            Endereços
          </b-button>
        </template>
        <template #cell(cpf)="item">
          <b-button
            v-if="!item.item.cpf"
            variant="primary"
            @click="abrirModalCpf(item.item, item)"
          >
            Adicionar CPF
          </b-button>
          <div v-else>
            {{ item.item.cpf }}
          </div>
        </template>
        <template #cell(acoes)="item">
          <b-dropdown variant="outline-default">
            <b-dropdown-item @click="excluirVinculo(item)">
              {{ $t('GERAL.EXCLUIR') }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <cabecalho title="ACADEMICO_MATRICULAS.OBSERVACOES" title_type="body" />
      </div>
      <div class="col-12">
        <input-text-area
          ref="observacoes"
          v-model="form.observacao"
          :maxLength="1000"
          :label="$t('ACADEMICO_MATRICULAS.OBSERVACOES_LABEL')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <cabecalho title="ACADEMICO_MATRICULAS.OBSERVACOES_GERAIS" title_type="body" />
      </div>
      <div class="col-12">
        <input-text-area
          ref="observacoesGerais"
          v-model="form.observacoesGerais"
          :maxLength="1000"
          :label="$t('ACADEMICO_MATRICULAS.OBSERVACOES_GERAIS_LABEL')"
        />
      </div>
    </div>
    <modal-vinculos-formulario
      :exibir="exibirModalPessoaResponsavel"
      :form="form"
      @fechar="fecharModalResponsavel"
    />
    <modal-vinculos-contatos
      :exibir="exibirModalContatos"
      :pessoaSelecionada="pessoaSelecionada"
      @fechar="fecharModalContatos"
    />
    <modal-vinculos-enderecos
      :exibir="exibirModalEnderecos"
      :pessoaSelecionada="pessoaSelecionada"
      @fechar="fecharModalEnderecos"
    />
    <modal-adicionar-cpf
      :exibir="exibirModalCpf"
      :pessoaSelecionada="pessoaSelecionada"
      @fechar="fecharModalCpf"
    />
  </div>
</template>
<script>
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import rotas from '@/common/utils/rotas';

import { Cabecalho } from '@/components/headers/index';
import ModalVinculosFormulario from '@/views/academico/matriculas/components/ModalVinculosFormulario.vue';
import ModalVinculosContatos from '@/views/academico/matriculas/components/ModalVinculosContatos.vue';
import ModalVinculosEnderecos from '@/views/academico/matriculas/components/ModalVinculosEnderecos.vue';
import ModalAdicionarCpf from './ModalAdicionarCpf.vue';
import {
  InputSelectTyping,
  InputText,
  InputTextArea,
  InputSelectMultiple,
} from '@/components/inputs';
// import MatriculaService from '@/common/services/matriculas/matriculas.service';
// import { START_LOADING, STOP_LOADING } from '@/store/Store';
import PessoasService from '@/common/services/pessoa/pessoa.service';

export default {
  components: {
    ModalAdicionarCpf,
    Cabecalho,
    InputSelectMultiple,
    ModalVinculosFormulario,
    ModalVinculosContatos,
    ModalVinculosEnderecos,
    InputSelectTyping,
    InputText,
    InputTextArea,
  },
  props: {
    form: { type: Object, default: Object },
    listaInstituicoesDeEnsino: { type: Array, default: () => [] },
  },
  data() {
    return {
      pessoas: [],
      loadingPessoas: false,
      camposVinculos: [
        {
          key: 'codigo',
          label: 'Código pessoa',
          sortable: true,
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'cpf',
          label: 'CPF',
        },
        {
          key: 'tipoFiliacaoDescricao',
          label: 'Filiação',
          sortable: true,
        },
        {
          key: 'tipoResponsavelDescricao',
          label: 'Responsável por',
          sortable: true,
        },
        {
          key: 'contatos',
          label: 'Contatos',
        },
        {
          key: 'enderecos',
          label: 'Endereços',
        },
        {
          key: 'acoes',
          label: 'Mais ações',
        },
      ],
      exibirModalPessoaResponsavel: false,
      exibirModalCpf: false,
      exibirModalContatos: false,
      exibirModalEnderecos: false,
      pessoaSelecionada: {},
    };
  },
  methods: {
    valid() {
      return true;
    },
    async excluirVinculo(data) {
      await mensagem
        .confirmacao(null, 'Você realmente quer excluir essa pessoa?')
        .then(({ isConfirmed }) => {
          if (!isConfirmed) return;
          return this.form.vinculos.splice(data.index, 1);
        });
    },
    // removerPessoa(pessoaId, index) {
    //   this.$store.dispatch(START_LOADING);

    //   MatriculaService.removerVinculo(this.form.id, pessoaId)
    //     .then(() => this.form.vinculos.splice(index, 1))
    //     .catch((err) => {
    //       mensagem.showErrors(err);
    //     })
    //     .finally(() => {
    //       this.$store.dispatch(STOP_LOADING);
    //     });
    // },
    buscarPessoasSemMatriculaPorNome(nome) {
      this.loadingPessoas = true;
      PessoasService.buscarTodosSemMatriculaPorNome(nome)
        .then((data) => {
          this.pessoas = data.itens;
          this.form.pessoaId = this.$route.params?.idPessoa;
        })
        .catch((erro) => {
          mensagem.showErrors(erro);
        })
        .finally(() => {
          this.loadingPessoas = false;
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    abrirModalPessoaResponsavel() {
      this.exibirModalPessoaResponsavel = true;
    },
    fecharModalResponsavel() {
      this.exibirModalPessoaResponsavel = false;
    },
    abrirModalContatos(item) {
      this.pessoaSelecionada = item;
      this.exibirModalContatos = true;
    },
    fecharModalContatos() {
      this.pessoaSelecionada = {};
      this.exibirModalContatos = false;
    },
    abrirModalCpf(item) {
      this.pessoaSelecionada = item;
      this.exibirModalCpf = true;
    },
    fecharModalCpf(pessoa) {
      if (pessoa) {
        const pessoaEditada = this.form.vinculos.findIndex(
          (i) => i.codigo == pessoa.codigo
        );
        this.form.vinculos[pessoaEditada].cpf = pessoa.cpf;
      }
      this.exibirModalCpf = false;
    },
    abrirModalEnderecos(item) {
      this.pessoaSelecionada = item;
      this.exibirModalEnderecos = true;
    },
    fecharModalEnderecos() {
      this.pessoaSelecionada = {};
      this.exibirModalEnderecos = false;
    },
    irPara(rota, id, linkRetornar) {
      rotas.irPara(rota, id, linkRetornar);
    },
  },
};
</script>
